import { LogoPropsType } from './logoTypes';

export default function WikipediaWLogo({ className, monochrome }: LogoPropsType) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      width="800"
      height="800"
      viewBox="0 0 800 800"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 0V800H800V0H0ZM676.923 207.72C676.923 211.093 674.184 213.822 670.81 213.822H653.691C647.457 213.822 641.834 217.602 639.483 223.385L483.325 606.521L404.677 429.978L320.527 606.52L159.488 223.233C157.09 217.538 151.515 213.836 145.336 213.836H129.194C125.822 213.836 123.077 211.093 123.077 207.719V193.479H262.236L261.844 207.884C261.756 211.2 259.044 213.836 255.731 213.836H232.436C223.775 213.836 217.839 222.576 221.016 230.623L334.08 516.645L391.262 392.716L319 223.161C316.585 217.509 311.042 213.822 304.879 213.822H293.64C290.268 213.822 287.524 211.093 287.524 207.72V193.48H392.026V207.72C392.026 211.093 389.284 213.822 385.913 213.822C377.099 213.822 371.147 222.847 374.623 230.956L417.327 330.423L460.93 231.047C464.484 222.935 458.548 213.837 449.676 213.837H433.352C429.964 213.837 427.235 211.095 427.235 207.72V193.48H536.672V207.72C536.672 211.093 533.943 213.837 530.555 213.837H512.343C506.391 213.837 500.965 217.287 498.447 222.681L431.086 366.725L493.982 514.52L604.028 230.49C607.086 222.455 601.15 213.836 592.547 213.836H565.345C561.973 213.836 559.228 211.093 559.228 207.719V193.479H676.923V207.72Z"
        fill={monochrome ? 'currentColor' : 'black'}
      />
    </svg>
  );
}
